import { Path } from '@/types/global';
import { FCRAWorkerCheckRecord } from '@/types/turn-api';

export const path = (path: Path<FCRAWorkerCheckRecord.Watchlist>) => path;
